import { API_URL } from '../config';

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('access_token')}`
});

export const contentService = {
  fetchContents: async () => {
    const response = await fetch(`${API_URL}/api/contents/`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to fetch contents');
    return response.json();
  },

  fetchContentTypes: async () => {
    const response = await fetch(`${API_URL}/api/content-types/`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to fetch content types');
    return response.json();
  },

  createContent: async (content) => {
    const payload = {
      title: content.title,
      description: content.description || '',
      content: content.content,
      content_type_id: content.content_type_id,
      state_id: content.state_id
    };
    const response = await fetch(`${API_URL}/api/contents/`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Failed to create content:', errorText);
      throw new Error('Failed to create content');
    }
    return response.json();
  },

  updateContent: async (content) => {
    const payload = {
      title: content.title,
      description: content.description,
      content: content.content,
      content_type_id: content.content_type_id,
      state_id: content.state_id
    };
    const response = await fetch(`${API_URL}/api/contents/${content.id}/`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Failed to update content:', errorText);
      throw new Error('Failed to update content');
    }
    return response.json();
  },

  deleteContent: async (contentId) => {
    const response = await fetch(`${API_URL}/api/contents/${contentId}/`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to delete content');
  },

  fetchCanvasDocuments: async (limit = 20) => {
    // Get Canvas content type ID, then filter documents by it
    const types = await fetch(`${API_URL}/api/content-types/`, {
      headers: getAuthHeaders()
    }).then(res => res.ok ? res.json() : Promise.reject(new Error('Failed to fetch content types')));
    
    const typesArray = Array.isArray(types) ? types : (types.results || types);
    const canvasType = typesArray.find(t => t.name === 'Canvas');
    
    if (!canvasType) {
      throw new Error('Canvas content type not found');
    }
    
    const response = await fetch(`${API_URL}/api/contents/?content_type=${canvasType.id}&page_size=${limit}&order_by=updated_at&order_dir=desc`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to fetch canvas documents');
    const data = await response.json();
    return Array.isArray(data) ? data : (data.results || []);
  },

  shareContent: async (contentId) => {
    try {
      const response = await fetch(`${API_URL}/api/contents/${contentId}/share/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to share content');
      }
      
      return response.json();
    } catch (error) {
      console.error('Error sharing content:', error);
      throw error;
    }
  },

  unshareContent: async (contentId) => {
    try {
      const response = await fetch(`${API_URL}/api/contents/${contentId}/unshare/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to unshare content');
      }
      
      return response.json();
    } catch (error) {
      console.error('Error unsharing content:', error);
      throw error;
    }
  }
}; 